<template>
  <div class="uploadImg">
    <Upload
      multiple
      type="drag"
      :action="uploadUrl"
      :on-success="handleSuccess"
      :format="['jpg', 'jpeg', 'png', 'gif']"
      :max-size="5120"
      :on-format-error="handleFormatError"
      :on-exceeded-size="handleMaxSize"
      :before-upload="handleBeforeUpload"
      :show-upload-list="false"
    >
      <div style="padding: 20px 0">
        <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
        <p>Click or drag files here to upload</p>
      </div>
    </Upload>
    <div style="height: 20px;width: 100%;"></div>
    <div
      class="upload-list"
      v-for="(item, index) in uploadList"
      :key="item.url"
    >
      <template v-if="item.status === 'finished'">
        <img :src="item.url" />
        <div class="upload-list-cover">
          <div style="min-height: 15px;">
            <Icon
              v-if="index > 0"
              type="md-arrow-round-up"
              @click.native="up(item, index)"
            ></Icon>
          </div>

          <Icon type="ios-eye-outline" @click.native="handleView(index)"></Icon>
          <Icon
            type="ios-trash-outline"
            @click.native="handleRemove(item)"
          ></Icon>
        </div>
      </template>
      <template v-else>
        <Progress
          v-if="item.showProgress"
          :percent="item.percentage"
          hide-info
        ></Progress>
      </template>
    </div>
    <Upload
      :show-upload-list="false"
      :on-success="handleSuccess"
      :format="['jpg', 'jpeg', 'png', 'gif']"
      :max-size="5120"
      :on-format-error="handleFormatError"
      :on-exceeded-size="handleMaxSize"
      :before-upload="handleBeforeUpload"
      multiple
      type="drag"
      :action="uploadUrl"
      style="display: inline-block;width:58px;"
    >
      <div style="width: 58px;height:58px;line-height: 58px;">
        <Icon type="ios-camera" size="20"></Icon>
      </div>
    </Upload>
    <Modal title="图片详情" v-model="visible" class="img-detail">
      <span
        class="img-detail-button pre"
        :class="{ disable: index == 0 }"
        @click="preImg"
        ><Icon type="ios-arrow-back"
      /></span>
      <img :src="url" v-if="visible" style="width: 100%" />
      <span
        class="img-detail-button next"
        :class="{ disable: index == this.uploadList.length - 1 }"
        @click="nextImg"
        ><Icon type="ios-arrow-forward"
      /></span>
    </Modal>
  </div>
</template>
<script>
let urlPrefix = process.env.VUE_APP_URL;
export default {
  props: ["srcData"],
  data() {
    return {
      index: 0,
      url: "",
      visible: false,
      uploadList: [],

      uploadUrl:
        urlPrefix + "/file/imgUpload?token=" + this.$store.getters.token,
      isLoadSrc: false,
    };
  },
  methods: {
    preImg() {
      this.index = this.index - 1;
      this.url = this.uploadList[this.index].url;
    },
    nextImg() {
      this.index = this.index + 1;
      this.url = this.uploadList[this.index].url;
    },

    up(item, index) {
      // console.log(item, index);
      let preItem = this.uploadList[index - 1];
      this.$set(this.uploadList, index - 1, item);
      this.$set(this.uploadList, index, preItem);
    },

    handleView(index) {
      this.index = index;
      this.url = this.uploadList[index].url;
      this.visible = true;
    },
    handleRemove(file) {
      this.uploadList.splice(this.uploadList.indexOf(file), 1);
    },
    handleSuccess(res, file) {
      file.url = res.url;
      this.uploadList.push(file);
    },
    handleFormatError(file) {
      this.$Notice.warning({
        title: "该文件格式错误",
        desc: file.name + "格式不正确,请选择png,jpg,jpeg,gif格式",
      });
    },
    handleMaxSize(file) {
      this.$Notice.warning({
        title: "文件大小才超出5M",
        desc: file.name + "文件大小超出5M,请选择5M以下的文件",
      });
    },
    handleBeforeUpload() {
      const check = this.uploadList.length < 15;
      if (!check) {
        this.$Notice.warning({
          title: "最多上传15张图片",
        });
      }
      return check;
    },
  },
  watch: {
    uploadList: function(val) {
      let images = "";
      val.forEach((item) => {
        images = images + item.url + ";";
      });

      this.$emit("uploadChange", images);
    },
    srcData: function(val) {
      if (this.isLoadSrc || !this.srcData) return;
      this.isLoadSrc = true;
      let imgUrls = [];
      let images = val.split(";");
      images.forEach((item) => {
        if (item) {
          imgUrls.push({
            url: item,
            status: "finished",
          });
        }
      });

      this.uploadList = imgUrls;
    },
    keyNum: {
      handler: function() {
        if (!this.srcData) return;
        let imgUrls = [];
        let images = this.srcData.split(";");
        images.forEach((item) => {
          if (item) {
            imgUrls.push({
              url: item,
              status: "finished",
            });
          }
        });

        this.uploadList = imgUrls;
      },
      immediate: true,
    },
  },
  mounted() {},
};
</script>
<style lang="less" scoped>
.upload-list {
  display: inline-block;
  width: 60px;
  height: 60px;
  text-align: center;
  line-height: 60px;
  border: 1px solid transparent;
  border-radius: 4px;
  overflow: hidden;
  background: #fff;
  position: relative;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
  margin-right: 4px;
}

.upload-list img {
  width: 100%;
  height: 100%;
}

.upload-list-cover {
  display: none;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.6);
  line-height: 29px;
}

.upload-list:hover .upload-list-cover {
  display: block;
}

.upload-list-cover i {
  color: #fff;
  font-size: 20px;
  cursor: pointer;
  margin: 0 2px;
}

.img-detail {
  position: relative;

  .ivu-modal-body {
    padding: 0 40px;
  }

  .img-detail-button {
    width: 36px;
    height: 36px;
    background: rgba(0, 0, 0, 0.4);
    border-radius: 18px;
    position: absolute;
    top: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    transform: translate(0, -50%);
    cursor: pointer;
    i {
      color: #fff;
      font-size: 24px;
      line-height: 36px;
      text-align: center;
    }

    &.pre {
      left: 10px;
    }

    &.next {
      right: 10px;
    }

    &.disable {
      opacity: 0.4;
      cursor: default;
      pointer-events: none;
    }
  }
}
</style>
